export enum GraphqlExceptions {
  GraphqlQueryError = 'GraphqlQueryError',
  GraphqlQueryFailed = 'GraphqlQueryFailed'
}
